module.exports = __webpack_public_path__ + "media/images/legs-e7883ba7970e3c7065d2557a66ba7f80.jpg";